/* Revival Sale Manager — Advanced Price Preview v2.2.4.
 * Simulation only. Never edit live prices, Recharge controls, cart payloads, or checkout.
 * Enabled only on a draft-theme preview with ?rsm_advanced_preview=1.
 */
(function () {
  'use strict';
  if (new URLSearchParams(location.search).get('rsm_advanced_preview') !== '1') return;

  var configEl = document.getElementById('revival-sale-advanced-config');
  var cfg;
  try { cfg = JSON.parse(configEl && configEl.textContent || 'null'); } catch (_) { return; }
  // A preview must NEVER masquerade as an actual published campaign.
  if (!cfg || cfg.version !== 2 || !Array.isArray(cfg.rules) || cfg.enabled === true || cfg.storefront_ready === true) return;

  function gid(kind, id) {
    var str = String(id || '');
    return str.indexOf('gid://') === 0 ? str : 'gid://shopify/' + kind + '/' + str;
  }
  function bounded(n) {
    if (n === null || n === undefined || n === '') return 0;
    n = Number(n);
    return Number.isFinite(n) && n >= 0 && n <= 100 ? n : 0;
  }
  function rate(ctx, mode) {
    if (!ctx || ctx.giftCard) return 0;
    var productId = gid('Product', ctx.productId);
    var variantId = gid('ProductVariant', ctx.variantId);
    var rules = cfg.rules;
    if (rules.some(function (r) {
      return (r.type === 'exclude_product' && r.id === productId) ||
             (r.type === 'exclude_variant' && r.id === variantId);
    })) return 0;
    var hits = rules.filter(function (r) {
      return (r.type === 'variant' && r.id === variantId) ||
             (r.type === 'product' && r.id === productId) ||
             (r.type === 'collection' && ctx.collections.indexOf(r.id) !== -1);
    });
    var rank = { variant: 3, product: 2, collection: 1 };
    hits.sort(function (a, b) {
      return rank[b.type] - rank[a.type] || (Number(b.priority) || 0) - (Number(a.priority) || 0) || String(a.id).localeCompare(String(b.id));
    });
    for (var i = 0; i < hits.length; i++) {
      if (hits[i][mode] !== null && hits[i][mode] !== undefined) return bounded(hits[i][mode]);
    }
    return bounded(cfg.global && cfg.global[mode]);
  }
  function preview(cents, pct) {
    // Per-unit GBP checkout estimate, matching the Sale Manager storefront adapter.
    var bp = Math.round(Number(pct) * 100);
    return Number(cents) - Math.floor(Number(cents) * bp / 10000 + 1e-9);
  }
  function money(cents) {
    var code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: code }).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + ' ' + code; }
  }
  function element(tag, cls, value) {
    var e = document.createElement(tag);
    e.className = cls;
    if (value !== undefined) e.textContent = value;
    return e;
  }

  var banner = element('div', 'rsm-preview-banner', 'ADVANCED SALE SIMULATION — no discount applied to checkout');
  banner.setAttribute('role', 'status');
  document.body.appendChild(banner);

  function renderCards() {
    document.querySelectorAll('dl[data-price][data-rsm-product-id][data-rsm-variant-id][data-revival-base-cents]').forEach(function (card) {
      if (card.querySelector('.rsm-preview-card-note')) return;
      var base = Number(card.getAttribute('data-revival-base-cents'));
      var cols = (card.getAttribute('data-rsm-collection-ids') || '').split(',').filter(Boolean).map(function (id) { return gid('Collection', id); });
      var pct = rate({
        productId: card.getAttribute('data-rsm-product-id'),
        variantId: card.getAttribute('data-rsm-variant-id'),
        collections: cols,
        giftCard: card.getAttribute('data-rsm-gift-card') === 'true'
      }, 'one_time');
      if (base > 0 && pct > 0) card.appendChild(element('div', 'rsm-preview-card-note', 'SIMULATION ONLY · ' + pct + '% → ' + money(preview(base, pct))));
    });
  }

  function activePurchaseMode() {
    // Recharge's active wrapper is authoritative on this theme. Some inputs are
    // changed by the widget without dispatching a native change event.
    var active = document.querySelector('.rc-option--active, .rc_widget__option--active');
    if (active) {
      if (active.matches('[data-option-subsave], .rc-option__subsave, .rc_widget__option--subsave')) return 'subscription';
      if (active.matches('[data-option-onetime], .rc-option__onetime, .rc_widget__option--onetime')) return 'one_time';
    }
    var subInput = document.querySelector('.rc_widget__option__input--subsave, .rc-radio__input[name="selling_plan"]');
    if (subInput && subInput.checked) return 'subscription';
    return 'one_time';
  }

  function readSelection(data) {
    var mode = activePurchaseMode();
    var selectedBox = document.querySelector('.product-bundle-options .bundle-option.selected');
    if (selectedBox) {
      var count = Number(selectedBox.getAttribute('data-bundle-size'));
      if (!Number.isInteger(count) || count < 1 || count > 12) return { mode: mode, error: 'Invalid box selection' };
      var lines = [], missing = [];
      for (var i = 1; i <= count; i++) {
        // These exact hidden inputs are also used by the theme's /cart/add.js handler.
        var input = document.getElementById('bundle-variant-' + i);
        var value = input && String(input.value || '').trim();
        var v = data.variants.find(function (item) { return String(item.numericId) === value; });
        if (!v || !v.available) { missing.push(i); continue; }
        lines.push({ box: i, variant: v });
      }
      return { mode: mode, boxes: count, lines: lines, missing: missing };
    }
    // Ordinary non-bundle products: prefer the live form field, not a stale
    // ?variant URL retained from an earlier selection.
    var formInput = document.querySelector('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]:checked, form[action*="/cart/add"] input[name="id"]');
    var urlVariant = new URLSearchParams(location.search).get('variant');
    var value = (formInput && formInput.value) || urlVariant || String(data.variants[0].numericId);
    var variant = data.variants.find(function (item) { return String(item.numericId) === String(value); });
    if (!variant || !variant.available) return { mode: mode, error: 'Selected variant unavailable or unknown' };
    return { mode: mode, boxes: 1, lines: [{ box: 1, variant: variant }], missing: [] };
  }

  function renderProduct() {
    var node = document.getElementById('rsm-advanced-preview-product');
    if (!node) return;
    var data;
    try { data = JSON.parse(node.textContent || 'null'); } catch (_) { return; }
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return;

    var panel = element('section', 'rsm-preview-panel');
    panel.setAttribute('aria-label', 'Advanced sale price simulation');
    panel.appendChild(element('strong', 'rsm-preview-heading', 'Advanced pricing — simulation only'));
    panel.appendChild(element('div', 'rsm-preview-meta', 'Illustrative prices only; Recharge, cart and checkout are unchanged.'));
    var detail = element('div', 'rsm-preview-detail');
    panel.appendChild(detail);
    panel.appendChild(element('div', 'rsm-preview-meta', 'Actual checkout rounding and promotional combinations may differ.'));
    document.body.appendChild(panel);

    var previous = '';
    function drawIfChanged() {
      var state = readSelection(data);
      var key = JSON.stringify(state);
      if (key === previous) return;
      previous = key;
      detail.replaceChildren();
      detail.appendChild(element('div', 'rsm-preview-mode', 'Selected: ' + (state.mode === 'subscription' ? 'Subscription' : 'One-time purchase') + (state.boxes ? ' · ' + state.boxes + (state.boxes === 1 ? ' box' : ' boxes') : '')));
      if (state.error) { detail.appendChild(element('div', 'rsm-preview-warning', state.error)); return; }

      var totalBase = 0, totalEstimate = 0, anyPromotion = false;
      state.lines.forEach(function (line) {
        var v = line.variant;
        var pct = rate({ productId: data.id, variantId: v.id, collections: data.collections || [], giftCard: !!data.giftCard }, state.mode);
        totalBase += v.price;
        // One-time: estimate rounding at each unit/line. Subscription is not
        // quoted since Recharge's selling-plan-adjusted price is not in this JSON.
        if (state.mode === 'one_time') totalEstimate += preview(v.price, pct);
        if (pct > 0) anyPromotion = true;
        var title = String(v.title || 'Default').split('*')[0].trim();
        var content = 'Box ' + line.box + ': ' + title + ' · Base ' + money(v.price);
        if (state.mode === 'one_time') content += pct > 0 ? ' · ' + pct + '% → ' + money(preview(v.price, pct)) : ' · No advanced discount';
        else if (cfg.subscriptionMode === 'total') content += pct > 0 ? ' · Target total savings ' + pct + '% (not a Recharge quote)' : ' · No advanced subscription discount';
        else content += pct > 0 ? ' · Additional ' + pct + '% (not a Recharge quote)' : ' · No extra advanced discount';
        detail.appendChild(element('div', 'rsm-preview-line', content));
      });

      if (state.missing && state.missing.length) {
        detail.appendChild(element('div', 'rsm-preview-warning', 'Select an available flavour for ' + state.missing.map(function (i) { return 'Box ' + i; }).join(', ') + ' to preview the full total.'));
        return; // Never invent missing variants or display a misleading total.
      }
      if (state.mode === 'subscription') {
        detail.appendChild(element('div', 'rsm-preview-total', 'Selected boxes — Shopify base subtotal: ' + money(totalBase)));
        detail.appendChild(element('div', 'rsm-preview-meta', anyPromotion ?
          (cfg.subscriptionMode === 'total' ? 'Total-savings draft requires verified GBP selling-plan references and checkout certification; no subscription price is quoted here.' : 'Additional subscription rule detected; Recharge selling-plan prices are not calculated here.') :
          'No advanced subscription discount. Recharge determines the actual subscription total.'));
      } else {
        detail.appendChild(element('div', 'rsm-preview-total', 'One-time estimate: ' + money(totalBase) + ' → ' + money(totalEstimate)));
        detail.appendChild(element('div', 'rsm-preview-meta', anyPromotion ? 'Per-box estimate, before shipping and other discounts.' : 'No advanced one-time promotion for these variants.'));
      }
    }

    function schedule() {
      setTimeout(drawIfChanged, 0);
      setTimeout(drawIfChanged, 75);
      setTimeout(drawIfChanged, 280);
    }
    drawIfChanged();
    // The bundle component updates hidden input .value programmatically and
    // does not dispatch a change event. React to dropdown radio clicks and
    // poll the small selection snapshot as a fallback, only in opt-in preview.
    document.addEventListener('click', function (event) {
      if (event.target.closest('.bundle-option, dropdown-select, .rc_widget__option, .rc-option')) schedule();
    });
    document.addEventListener('change', function (event) {
      if (event.target.closest('form[action*="/cart/add"], dropdown-select, .rc-widget, .rc_container, .rc-container')) schedule();
    });
    window.addEventListener('popstate', schedule);
    setInterval(drawIfChanged, 450);
  }

  renderProduct();
  renderCards();
  var timer;
  var observer = new MutationObserver(function (records) {
    // Changes made to our preview panel should not trigger a card rescan.
    var external = records.some(function (record) {
      var target = record.target;
      return !(target.nodeType === 1 && target.closest('.rsm-preview-panel, .rsm-preview-banner, .rsm-preview-card-note'));
    });
    if (!external) return;
    clearTimeout(timer);
    timer = setTimeout(renderCards, 250);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
